import { Box, Stack } from '@mui/material';
import { ReactNode, useState } from 'react';
import { useDetailsPanelDisplay } from '../hooks/useDetailsPanelDisplay';
import DetailsPendencyFab from './DetailsPendencyFab/DetailsPendencyFab';

interface DetailsPanelProps {
  children: ReactNode;
}

export const DETAILS_PANEL_WIDTH = 340;

export const DetailsPanel = ({ children }: DetailsPanelProps) => {
  const { isFloating, hasBackdrop } = useDetailsPanelDisplay();
  const [scrollNode, setScrollNode] = useState<HTMLDivElement | null>(null);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        width: '100%',
        height: '100%',
        minHeight: 0,
      }}
    >
      <Stack
        ref={setScrollNode}
        sx={{
          width: '100%',
          height: '100%',
          flexShrink: 0,
          gap: 1,
          p: 1,
          overflowX: 'hidden',
          overflowY: 'auto',
          bgcolor: hasBackdrop ? 'transparent' : 'background.paper',
          boxSizing: 'border-box',
          ...(isFloating
            ? {
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': { display: 'none' },
              }
            : {
                scrollbarGutter: 'stable',
              }),
        }}
      >
        {children}
      </Stack>

      <DetailsPendencyFab scrollNode={scrollNode} />
    </Box>
  );
};
